// extracted by mini-css-extract-plugin
module.exports = {"borderVertical":"HistoryEventInfo_borderVertical_32hDF"};